<template>
  <Row :gutter="16" :class="{ dark: dark }">
    <Col span="24">
      <slot name="topcontent"></slot>
    </Col>

    <Col
      :span="item.span ? item.span : 8"
      v-for="(item, index) in forms"
      :key="index"
    >
      <ly-form-item
        :color="dark ? '#fff' : '#666'"
        :hideLabel="item.hideLabel"
        :label="item.title"
      >
        <p v-if="item.type == 'Input'">{{ data[item.key] }}</p>
        <p v-if="item.type == 'InputNumber'">{{ data[item.key] }}</p>
        <p v-if="item.type == 'lyInput'">{{ data[item.key] }}</p>
        <p v-if="item.type == 'lyyymmdd'">{{ showTime(item) }}</p>
        <p v-if="item.type == 'Select'">{{ showSelect(item) }}</p>
        <p v-if="item.typeShow == 'bool'">
          {{ data[item.keyText] ? "是" : "否" }}
        </p>
        <p v-if="item.type == 'checkbox'">
          {{ data[item.key].join("/") }}
        </p>

        <slot v-if="item.slotForm" :name="item.slotForm"></slot>
        <imgList
          v-if="item.typeShow == 'lyPhoto'"
          :data="data[item.keyText]"
        ></imgList>
      </ly-form-item>
    </Col>
    <Col span="24">
      <slot name="endcontent"></slot>
    </Col>
  </Row>
</template>

<script>
export default {
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      forms: [],
      data: {}
    };
  },
  methods: {
    reach(v, forms) {
      this.data = v;

      for (let i = 0; i < forms.length; i++) {
        forms[i].keyText = forms[i].key;

        if (forms[i].key1) {
          forms[i].keyText = forms[i].key1;
        }
        if (forms[i].key2) {
          forms[i].keyText = forms[i].key2;
        }
        forms[i].typeShow = "text";
        if (forms[i].slotForm) {
          forms[i].typeShow = null;
        }
        if (forms[i].type == "Select") {
          forms[i].typeShow = "Select";
        }
        if (forms[i].type == "lyPhoto") {
          forms[i].typeShow = "lyPhoto";
        }
        if (forms[i].type == "bool") {
          forms[i].typeShow = "bool";
        }
        if (forms[i].type == "checkbox" && !forms[i].selectType) {
          forms[i].typeShow = "checkbox";
        }
        this.forms = forms;
      }
    },
    showSelect(item) {
      let data = this.data;
      let text = data[item.key];
      if (item.selectType == "obj") {
        let options = item.selectItems;

        let m = options.find(a => a.id == data[item.key]);
        text = m.name;
      }
      return text;
    },
    showTime(item) {
      let data = this.data[item.key];
      return this.utils.time(data);
    }
  },
  mounted() {},
  watch: {}
};
</script>

<style scoped>
.dark {
  background: #000;
  color: #fff;
}
.dark .form {
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/dataDetail.vue